import { Component, OnInit, Input, OnChanges, SimpleChanges } from "@angular/core";
import { DisponibiliteModel } from "./disponibilite.model";
import { BaseModel, FormGeneratorService } from "@ngx-resource-toolkit/core";
import { FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { ToasterService } from "angular2-toaster";
import { SettingsService } from "../../core/settings/settings.service";

@Component({
    selector: 'disponibilite',
    templateUrl: './disponibilite.component.html',
})
export class DisponibiliteComponent implements OnInit, OnChanges {

    @Input() disponibilites: DisponibiliteModel[];
    @Input() resource: string;
    @Input() model: DisponibiliteModel;

    public form: FormGroup

    constructor(private settings: SettingsService, private toaster: ToasterService, private http: HttpClient, private formGenerator: FormGeneratorService) {

    }

    ngOnInit(): void {
        // console.log('ngOnInit', 'this.disponibilites', this.disponibilites);
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (this.model) {
            this.form = this.formGenerator.createFormGroup(this.model, 'create');
        }

        console.log('DisponibiliteComponent', 'ngOnChanges', 'this.disponibilites', this.disponibilites);
        console.log('DisponibiliteComponent', 'ngOnChanges', 'this.model', this.model);
        console.log('DisponibiliteComponent', 'ngOnChanges', 'this.form', this.form);
    }

    addDisponibilite() {
        // console.log('this.form', this.form);
        this.model.getResource(this.resource || 'default', 'save').call(this.http, this.form).subscribe((data) => {
            console.log('DisponibiliteComponent', 'addDisponibilite data', data);
            const values = {...this.form.value, id: data};
            const dispo = new DisponibiliteModel({
                ...values,
                anneeScolaire: this.settings.getUserSetting('anneeScolaire')
            });
            console.log('new dispo', dispo, values);

            this.disponibilites = [...this.disponibilites, dispo];

        }, (err) => {
            console.log('DisponibiliteComponent', 'addDisponibilite error', err);
            this.toaster.pop('error', 'Erreur lors de l\'ajout de la disponibilité');
        })
    }
}


// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/disponibilite/disponibilite.component.ts